<template>
    <div class="problem-list-wrap">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">常见问题</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input class="search-input"
                              size="small"
                              placeholder="请输入标题"
                              v-model="search.title"
                              @keyup.enter.native="getData"
                              style="width: 320px !important;margin-right:20px;">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="getData(1)"></i>
                    </el-input>
                    <div style="margin-right:20px">
                        <span class="label"
                              style="margin-right:10px">类型</span>
                        <el-select size="small"
                                   :style="{width: '220px!important'}"
                                   v-model="search.type"
                                   @change="getData(1)">
                            <el-option value="">全部</el-option>
                            <el-option v-for="item in typeList"
                                       :key="item.incId"
                                       :label="item.dictDataValue"
                                       :value="item.dictDataCode"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <span class="label"
                              style="margin-right:10px">更新时间</span>
                        <el-date-picker style="width:220px !important"
                                        v-model="updateTime"
                                        @change="handleUpdateTime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        type="date"
                                        size="small"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <el-button size="small"
                           @click="clickAdd">新增问题</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="problemList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column width="50"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime"
                                     label="创建时间"
                                     width="150"></el-table-column>
                    <el-table-column prop="type"
                                     label="类型"
                                     width="100"></el-table-column>
                    <el-table-column prop="number"
                                     label="排列序号"
                                     :width="search.type ? 110 : 80">
                        <template slot-scope="scope">
                            <el-input-number v-if="search.type"
                                             v-model.trim="scope.row.number"
                                             @blur="((val)=>{numberChange(val,scope.row.questionId)})"
                                             placeholder="请输入排列序号"
                                             size="small"
                                             :controls="false"
                                             step-strictly></el-input-number>
                            <span v-else>{{scope.row.number}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title"
                                     label="标题"></el-table-column>
                    <el-table-column fixed="right"
                                     label="操作"
                                     width="135">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isRelease">
                                <span @click="clickOffline(scope.row.questionId)"
                                      class="link-btn">下线</span>
                            </div>
                            <div v-else>
                                <span @click="clickOnLine(scope.row.questionId)"
                                      class="link-btn">上线</span>
                                <span @click="clickEdit(scope.row)"
                                      class="link-btn">编辑</span>
                                <span @click="clickDelete(scope.row.questionId)"
                                      class="link-btn">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
            <message-box :dialog-visible="dialogVisible"
                         :id="questionId"
                         warning-text="确认将此问题删除？"
                         @handleConfirm="handleConfirm"
                         @handleClose="handleClose" />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getProblemList, deleteProblem, addOrEditProblem, getTime, updateTime } from '@/api/consulting'
import MessageBox from '@/components/MessageBox'
export default {
    components: { MessageBox },
    data () {
        return {
            breadList: [{ label: '咨询专区' }, { label: '常见问题' }],
            search: {
                title: '',
                type: ''
            },
            updateTime: '',
            typeList: [],
            problemList: [],
            loading: true,
            questionId: '',
            dialogVisible: false,
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            }
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    created () {
        this.typeList = this.dictionary.CJWT
        this.getTime()
        let searchData = JSON.parse(sessionStorage.getItem('problemSearchData'))
        if (searchData) {
            this.search.title = searchData.title
            this.search.type = searchData.type
            this.page.current = searchData.current
        }
        sessionStorage.removeItem('problemSearchData')
        this.getData()
    },
    methods: {
        getTime () {
            getTime().then(res => {
                this.updateTime = res.results
            })
        },
        handleUpdateTime (val) {
            updateTime(val).then(res => {
                if (res.state === 200) {
                    this.$message({
                        message: '更新时间修改成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '1000'
                    })
                }
            })
        },
        numberChange (val, questionId) {
            addOrEditProblem({ number: val.target.value, questionId }).then(res => {
                if (res.state === 200) {
                    this.$message({
                        message: '排序序号修改成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '1000'
                    })
                    this.getData()
                }
            })
        },
        clickAdd () {
            this.$router.push('/counsel/commonProblem/add')
        },
        clickOffline (questionId) {
            addOrEditProblem({ isRelease: false, questionId }).then(res => {
                if (res.state === 200) {
                    this.$message({
                        message: '下线成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '1000'
                    })
                    this.getData()
                }
            })
        },
        clickOnLine (questionId) {
            addOrEditProblem({ isRelease: true, questionId }).then(res => {
                if (res.state === 200) {
                    this.$message({
                        message: '上线成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '1000'
                    })
                    this.getData()
                }
            })
        },
        clickEdit (row) {
            sessionStorage.setItem('editProblem', JSON.stringify(row))
            sessionStorage.setItem('problemSearchData', JSON.stringify({
                title: this.search.title,
                type: this.search.type,
                current: this.page.current
            }))
            this.$router.push('/counsel/commonProblem/edit')
        },
        clickDelete (questionId) {
            this.questionId = questionId
            this.dialogVisible = true
        },
        handleConfirm () {
            this.dialogVisible = false
            deleteProblem(this.questionId).then(res => {
                if (res.state === 200) {
                    this.$message({
                        message: '删除成功',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '1000'
                    })
                    this.getData()
                }
            })
        },
        handleClose () {
            this.dialogVisible = false
        },
        pageChange (val) {
            this.page.current = val
            this.getData()
        },
        getData (val) {
            if (val) {
                this.page.current = 1
            }
            this.loading = true
            let params = {
                current: this.page.current,
                size: this.page.pageSize,
                title: this.search.title,
                type: this.search.type
            }
            getProblemList(params).then(res => {
                this.loading = false
                this.page.total = res.results.total
                res.results.records.forEach(item => {
                    this.typeList.forEach(type => {
                        if (type.dictDataCode === item.type) {
                            item.type = type.dictDataValue
                        }
                    })
                })
                this.problemList = res.results.records
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.search-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .search-show-wrap {
        display: flex;
    }
}
.table-wrap {
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
}
</style>
